import { render } from "./modal.html?vue&type=template&id=7bde4370&scoped=true&ts=true"
import script from "./modal.ts?vue&type=script&lang=ts"
export * from "./modal.ts?vue&type=script&lang=ts"

import "./modal.scss?vue&type=style&index=0&id=7bde4370&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bde4370"]])

export default __exports__